import React from "react";
import { Col, Container, Row } from "reactstrap";
import "./footer.css";

const Footer = () => (
  <Container fluid className="bg-dark footer py-5 mt-5">
    <Row className="text-center">
      <Col xs="12" md="6" lg="6">
        <address>
          <a
            href="https://goo.gl/maps/8YvSSaxsAFv"
            target="_blank"
            rel="noopener noreferrer"
          >
            Moonway Films <br />
            Rua Coelho da Rocha 112, 2.º dto
            <br />
            1350-080 Lisboa
            <br />
          </a>
        </address>
      </Col>
      <Col
        xs="12"
        md="6"
        lg="6"
        className="social text-center align-middle py-2"
      >
        <li className="list-inline-item">
          <a
            href="https://www.facebook.com/MoonwayFilms/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-facebook-f" />
          </a>
        </li>
        <li className="list-inline-item">
          <a
            href="https://www.linkedin.com/company/moonway-films/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-linkedin-in" />
          </a>
        </li>
        <li className="list-inline-item">
          <a
            href="https://vimeo.com/moonway"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-vimeo-v" />
          </a>
        </li>
      </Col>
    </Row>
  </Container>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js